<template>
    <div>
      <b-row class="text-center mb-4" align-h="center" v-if="!permissions.read">
        <b-col cols="1">
          <h3>You do not have permissions for this page</h3>
        </b-col>
      </b-row>
      <b-row class="text-center mb-4" align-h="center" v-if="loading && permissions.read">
        <b-col cols="1">
          <i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
        </b-col>
      </b-row>
      <b-row class="row text-white bg-kpmg-blue" v-if="!loading">
        <b-col align-self="center" cols="2" class=" cols text-center" align-v="center">
          <h1 justify="center" align="center" class="kstyle title justify-content-md-center mb-0">{{pageName}}</h1>
        </b-col>
        <b-col cols="8" align-self="center" align-v="center" class="search text-center cols justify-content-md-center">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-btn :disabled="!filter" @click="filter = ''">clear</b-btn>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="text-white bg-kpmg-blue mt-0 pb-4 mb-4" v-if="!loading && permissions.read" >
        <b-col align-self="center" cols="2" class="cols text-center" align-v="center"></b-col>
        <b-col align-self="center" cols="8" class="cols text-center" align-v="center">
            <a v-for="row in select" :key="'select-id' + row.property" class="mr-2 mb-3 mt-0 text-center" flex>
              <b-button v-b-toggle="'sidebar-' + row.property" class="filter-button">{{row.name}} <b-badge v-if="$data[row.selected].length != 0" variant="light">{{$data[row.selected].length}}</b-badge></b-button>
            </a>
            <b-btn class="filter-button" @click="filterReset">reset filters</b-btn>
        </b-col>
        <b-col align-self="center" cols="2" class="cols text-center" align-v="center"></b-col>
      </b-row>
      <b-row class="pl-4">
        <b-col>
          <div v-for="row in select" :key="'select-id' + row.property" class="mr-2 mb-3">
            <b-sidebar :id="'sidebar-' + row.property" :title="row.property.charAt(0).toUpperCase() + row.property.slice(1)" backdrop backdrop-variant="transparent" shadow>
              <div class="px-3 py-2 text-center" align-self="center" align-v="center">
                <b-button-group b-button-group class="mt-3 text-center">
                    <b-button variant="outline-primary" class="text-center" v-on:click="setSelection('all', row.property)">all</b-button>
                    <b-button variant="outline-primary" class="text-center" v-on:click="setSelection('none', row.property)">none</b-button>
                </b-button-group>
                <b-card class="m-3">
                <b-form-checkbox-group
                        v-model="$data[row.selected]"
                        :options="$data[row.options]"
                        button-variant="light"
                        size="md"
                        class="d-flex flex-column mx-auto text-left"
                        switches
                    ></b-form-checkbox-group>
                </b-card>
              </div>
            </b-sidebar>
          </div>
          <b-form inline>
            <span class="mr-2"><strong>Showing {{rowsShow.length}} out of {{rows.length}} {{pageName.toLowerCase()}}</strong></span>
            <!-- <b-button variant="outline-primary" @click="download" class="mr-2 button">download</b-button> -->
            <b-button class="mr-2 button" v-if="permissions.add" variant="outline-primary" :to="{ name: 'FormNew', params: {model: 'case' }}">add case</b-button>
            <!-- <b-form-select class ="button" v-model="viewSelected" :options="viewOptions" id="view-select"></b-form-select> -->
          </b-form>
          <b-card class="my-3 mb-2">
            <b-pagination v-if="rowsShow.length > perPage"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="perPage"
            />
            <div class="mb-3" v-for="row in rowsSplit" :key="row.id">
                <line-item
                :item="row"
                />
            </div>
            <b-pagination class="mb-0" v-if="rowsShow.length > perPage"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="perPage"
            />
          </b-card>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import _ from 'lodash'

import LineItem from '@/components/CaseSimple.vue'

export default {
  name: 'FilterInterface',
  props: ['pageName', 'rows', 'staticDataProperties', 'staticData', 'loading', 'permissions', 'perPage'],
  components: {
    LineItem
  },
  computed: {
    rowsShow: function () {
      let rows = []
      rows = this.rows
      _.each(this.select, row => {
        if (this[row.selected].length > 0) {
          rows = _.filter(rows, x => {
            let result = false
            if (Array.isArray(x[row.graph])) {
              _.each(this[row.selected], item => {
                if (_.find(x[row.graph], ['id', item])) {
                  result = true
                }
              })
            } else {
              if (x[row.graph].id === parseInt(this[row.selected])) {
                result = true
              }
            }
            return result
          })
        }
      })
      if (this.filter.length > 2) {
        rows = rows.filter(x => {
          const term = x.name + ' ' + x.objective + ' ' + x.description
          return term.toUpperCase().match(this.filter.toUpperCase())
        })
      }
      // not sure how to automate this for now, will likely need to be passed in
      // _.each(rows, row => {
      //   row.plain_description = striptags(row.description)
      //   row.plain_areas = row.areas.length > 0 ? row.areas.map(x => x.name) : ''
      //   row.plain_risks = row.controlrisks.length > 0 ? row.controlrisks.map(x => x.name) : ''
      //   row.plain_themes = row.controlthemes.length > 0 ? row.controlthemes.map(x => x.name) : ''
      //   row.plain_status = row.controlstatus.name
      // })
      return rows
    },
    rowsSplit () {
      const items = this.rowsShow
      // Return just page of items needed
      return items.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      )
    },
    totalRows () {
      return this.rowsShow.length
    }
  },
  created: function () {
    _.each(this.staticDataProperties, property => {
      const selected = property.property + 'Selected'
      const options = property.property + 'Options'
      this.$data[options] = this.staticData[property.property].map(x => {
        return { value: x.id, text: x.name }
      })
      const selectRow = {
        name: property.name,
        graph: property.graph,
        property: property.property,
        selected: selected,
        options: options
      }
      this.select.push(selectRow)
      const staticRow = {
        name: property.name,
        graph: property.graph,
        data: this.staticData[property.property].map(x => x.name)
      }
      this.dictionaries.push(staticRow)
    })
  },
  data () {
    const data = {
      dictionaries: [],
      filter: '',
      select: [],
      currentPage: 1
    }
    _.each(this.staticDataProperties, property => {
      const selected = property.property + 'Selected'
      const options = property.property + 'Options'
      data[selected] = []
      data[options] = []
    })
    return data
  },
  methods: {
    setSelection: function (button, selectionName) {
      if (button === "none") {
        this[selectionName + 'Selected'] = []
      }
      if (button === 'all') {
        this[selectionName + 'Selected'] = []
        _.each(this[selectionName + 'Options'], x => {
          this[selectionName + 'Selected'].push(x.value)
        })
      }
    },
    filterReset: function () {
      _.each(this.staticDataProperties, property => {
        const selected = property.property + 'Selected'
        this.$data[selected] = []
      })
      this.filter = ''
    }
  }
}
</script>

<style>
body {
  padding-top: 100px;
}
</style>
